var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7335 14C2.7335 14.3314 3.00213 14.6 3.3335 14.6C3.66487 14.6 3.9335 14.3314 3.9335 14H2.7335ZM3.3335 2V1.4H2.7335V2H3.3335ZM12.6668 2L13.173 2.32213C13.2906 2.13737 13.2982 1.90324 13.1928 1.71127C13.0874 1.51931 12.8858 1.4 12.6668 1.4V2ZM12.6668 9.33333V9.93333C12.8858 9.93333 13.0874 9.81403 13.1928 9.62206C13.2982 9.43009 13.2906 9.19596 13.173 9.01121L12.6668 9.33333ZM10.3335 5.66667L9.8273 5.34454C9.70223 5.54108 9.70223 5.79225 9.8273 5.98879L10.3335 5.66667ZM3.3335 2.6H12.6668V1.4H3.3335V2.6ZM3.9335 14V9.33333H2.7335V14H3.9335ZM3.9335 9.33333V2H2.7335V9.33333H3.9335ZM12.6668 8.73333H3.3335V9.93333H12.6668V8.73333ZM12.1606 1.67787L9.8273 5.34454L10.8397 5.98879L13.173 2.32213L12.1606 1.67787ZM9.8273 5.98879L12.1606 9.65546L13.173 9.01121L10.8397 5.34454L9.8273 5.98879Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.8ada32e589f81759e64a4a24c15809c0.svg";
export { ForwardRef as ReactComponent };